import { defineMessages } from 'react-intl';

export const scope = 'app.components.OfflineHandler';

// Copy for score saves: shown by offline sync, the scoring screens' submit, and the leave-flush.
export const messages = defineMessages({
  scoresRefused: {
    id: `${scope}.scoresRefused`,
    defaultMessage: '{count, plural, one {# score wasn\'t accepted and won\'t appear} other {# scores weren\'t accepted and won\'t appear}}. Ask an administrator to review {count, plural, one {it} other {them}}.'
  },
  scoresRefusedWithReason: {
    id: `${scope}.scoresRefusedWithReason`,
    defaultMessage: '{count, plural, one {# score wasn\'t accepted} other {# scores weren\'t accepted}} — {reason} Ask an administrator to review {count, plural, one {it} other {them}}.'
  },
  scoresRefusedMany: {
    id: `${scope}.scoresRefusedMany`,
    defaultMessage: '{count} scores weren\'t accepted and won\'t appear. That is unusual — tell an administrator now, who can review and restore them.'
  },
  scoresRefusedManyWithReason: {
    id: `${scope}.scoresRefusedManyWithReason`,
    defaultMessage: '{count} scores weren\'t accepted — {reason} That is unusual — tell an administrator now, who can review and restore them.'
  },
  scoresStuck: {
    id: `${scope}.scoresStuck`,
    defaultMessage: '{count, plural, one {# score is still on this device and can\'t be saved} other {# scores are still on this device and can\'t be saved}}. Your other scores are syncing — ask an administrator to look into {count, plural, one {it} other {them}}.'
  },
  scoreNotBuffered: {
    id: `${scope}.scoreNotBuffered`,
    defaultMessage: 'This score could not be saved on this device and will be lost. Write it down, reload the page, then enter it again. If this keeps happening, restart the device or score on another one. Don\'t clear this browser\'s data: scores not yet sent are stored in it.'
  },
  scoreStillSaving: {
    id: `${scope}.scoreStillSaving`,
    defaultMessage: 'This device is taking a long time to save a score. Keep this page open — the score shows as pending until it is saved.'
  },
  scoreNotBufferedSignedOut: {
    id: `${scope}.scoreNotBufferedSignedOut`,
    defaultMessage: 'You were signed out, so this score was not saved. Sign in again and re-enter it.'
  },
  clientUpdateRequired: {
    id: `${scope}.clientUpdateRequired`,
    defaultMessage: 'This page is out of date, so your scores can\'t be saved until you reload. Nothing is lost — they are still on this device and will sync once you reload.'
  },
  clientUpdateReload: {
    id: `${scope}.clientUpdateReload`,
    defaultMessage: 'Reload'
  },
  queuedChangesNotSaved: {
    id: `${scope}.queuedChangesNotSaved`,
    defaultMessage: '{count, plural, one {# change made offline could not be saved} other {# changes made offline could not be saved}}. Check and re-enter {count, plural, one {it} other {them}}.'
  },
});
